/* eslint-disable max-len */
/* eslint-disable react/prop-types */
/* eslint-disable max-len */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Input,
  Button,
  Row,
  Col,
  Spin,
  Modal,
  DatePicker,
} from 'antd';
import {
  CheckCircleOutlined,
} from '@ant-design/icons';
import Select from 'components/Select';
import { onError, onSuccess } from 'utils/handlers';
import { getEstadosGlobales } from 'api/catalogos/index';
import Table from 'components/Table';
import {
  getEvaluacionesAsistencia,
} from 'api/catalogos/TiposDeEvaluacionAsistencia';
import { ESTATUS_ACTIVO, ESTATUS_AUTORIZADO, ESTATUS_INACTIVO } from 'utils/constants';
import ModalConfirmation from 'components/ModalConfirmation';
import ModalDelete from 'components/ModalDelete';
import FormSubmitControls from 'components/FormSubmitControls';
import {
  autorizarIncidenciaParametro,
  deleteIncidenciaParametro,
  getIncidenciaParametro, getIncidenciasParametros, getIncidenciasParametrosPag, patchIncidenciaParametro, postIncidenciaParametro,
} from 'api/configuraciones/clock/Incidencias/IncidenciaParametros';
import { formatReceived } from 'utils/formatValues';
import moment from 'moment/moment';
import { getTiposDeIncidenciasUnidades } from 'api/nominas/incidencias/tiposIncidenciasUnidades';
import { getEvaluacionesInternas } from 'api/catalogos/Clock/TipoEvaluacionInterna';

export const ParametrosConfigPermission = {
  permissionModel: 'incidenciaparametros',
  catalogsModels: [],
  tabsModels: [],
};

const ParamaetrosConfigReloj = ({ permission }) => {
  const [form] = Form.useForm();
  const [isAdding, setAdding] = useState(true);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [evaluacionesAsistencia, setEvaluacionesAsistencia] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const [evaluacionInterna, setEvaluacionInterna] = useState([]);
  const [unidadIncidencia, setUnidadIncidencia] = useState([]);
  const [estados, setEstados] = useState([]);
  const [visibleAutorizar, setVisibleAutorizar] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [visibleConfirmInactivo, setVisibleConfirmInactivo] = useState(false);
  const [disableFields, setDisableFields] = useState(false);
  const [pageActual, setPageActual] = useState(1);

  const formInstances = [
    form,
  ];

  const handleNumber = (fieldName) => (e) => {
    const rawValue = e.target.value;

    // Keep only digits
    const filtered = rawValue.replace(/\D/g, '');

    // Convert to number
    const num = Number(filtered);

    // Only update if it's greater than 0
    if (num > -1) {
      form.setFieldsValue({ [fieldName]: num });
    } else {
      // If it's 0 or less, maybe clear it or set empty string
      form.setFieldsValue({ [fieldName]: '' });
    }
  };

  const fetchPaginated = async (page = 1, q = null) => {
    try {
      setLoading(true);

      const cleanPage = Number(String(page).replace(/\D/g, ''));
      const _data = await getIncidenciasParametrosPag({ page: cleanPage, ...q });

      const { results } = _data;

      setSelectedRowKeys([]);
      setPageActual(cleanPage);
      setData({ ..._data, results: [...results] });
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const fetchData = async () => {
    setLoading(true);
    const _data = await getIncidenciasParametros();
    setData(formatReceived(_data));
    setLoading(false);
  };
  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      const [
        _evaluacionesAsistencia,
        _unidadIncidencia,
        _evaluacionInterna,
        _data,
        _estados,
      ] = await Promise.all([
        getEvaluacionesAsistencia({ estados_globales: ESTATUS_AUTORIZADO }),
        getTiposDeIncidenciasUnidades(),
        getEvaluacionesInternas({ estados_globales: ESTATUS_AUTORIZADO }),
        getIncidenciasParametros(),
        getEstadosGlobales(),
      ]);
      if (mounted) {
        setEvaluacionesAsistencia(_evaluacionesAsistencia);
        setUnidadIncidencia(_unidadIncidencia);
        setEvaluacionInterna(_evaluacionInterna);
        setData(_data);
        setEstados(_estados);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
  }, []);

  const onCancel = () => {
    setVisible(false);
    setVisibleAutorizar(false);
    setDisableFields(false);
    setSelectedRowKeys([]);
    setSelectedData({});
  };
  const onClickEdit = async (responseData = null) => {
    setLoading(true);
    setAdding(false);
    const [key] = selectedRowKeys;
    const match = responseData || data?.results?.find((item) => item.id === key);
    const _parametrosConfigReloj = await getIncidenciaParametro(match.id);

    if (!evaluacionesAsistencia.length) {
      await getEvaluacionesAsistencia({ estados_globales: ESTATUS_AUTORIZADO }).then(setEvaluacionesAsistencia);
    }

    setTimeout(() => {
      if (_parametrosConfigReloj) {
        const formValues = {
          // Formatea la información recibida (según lógica definida en formatReceived)
          ...formatReceived(_parametrosConfigReloj),

          // Convierte el arreglo de tipos de evaluación de asistencia en un arreglo de IDs
          concepto_de_evaluacion: _parametrosConfigReloj.concepto_de_evaluacion?.id,

          tipo_de_unidad_de_incidencia: _parametrosConfigReloj.tipo_de_unidad_de_incidencia?.id,

          tipo_de_incidencia_unidad_de_descuento: _parametrosConfigReloj.tipo_de_incidencia_unidad_de_descuento?.id,

          evaluacion_interno: _parametrosConfigReloj.evaluacion_interno?.id,

          // Convierte la fecha de vigencia final a objeto moment si existe, si no null
          vigencia_final: _parametrosConfigReloj.vigencia_final
            ? moment(_parametrosConfigReloj.vigencia_final)
            : null,

          // Asigna el ID del estado global
          estados_globales: _parametrosConfigReloj.estados_globales?.id, //  aquí sí es un ID
        };
        form.resetFields();
        setTimeout(() => {
          form.setFieldsValue(formatReceived(formValues));
          setDisableFields(_parametrosConfigReloj?.estados_globales?.id !== ESTATUS_ACTIVO);
          setVisible(true);
        });
      }
    });
    setLoading(false);
  };
  const onClickAdd = () => {
    setAdding(true);
    form.resetFields();
    onCancel();
    setVisible(true);
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const onFinish = async (_continue = false) => {
    try {
      setLoading(true);
      await form.validateFields();

      const values = form.getFieldsValue();
      const [key] = selectedRowKeys;

      if (values.vigencia_final?.format) {
        values.vigencia_final = values.vigencia_final.format('YYYY-MM-DD');
      }
      const saved = await (key ? patchIncidenciaParametro(key, values) : postIncidenciaParametro(values));
      if (saved) {
        if (_continue) {
          await fetchData();
          setSelectedRowKeys([saved.id]);
          onClickEdit(saved);
        } else {
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(
        err,
        setLoading,
        formInstances,
      );
    }
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await deleteIncidenciaParametro(key);
        if (deleted) {
          setVisibleAlert(false);
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    setSelectedData({ ...record });

    const dataForForm = {
      ...record,
      vigencia_final: record.vigencia_final
        ? moment(record.vigencia_final)
        : null,
    };

    form.setFieldsValue(dataForForm);
  };
  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };
  const onConfirmAutorizar = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        onSuccess({}, 'No se puede autorizar un Parametro ya autorizado');
        return;
      }
      const saved = await autorizarIncidenciaParametro(key);
      if (saved) {
        const _data = await getIncidenciasParametros();
        setData(formatReceived(_data));
        onCancel();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const columns = [
    {
      titleText: 'Concepto de Evaluacion',
      dataIndex: 'concepto_de_evaluacion',
      key: 'concepto_de_evaluacion',
      width: 200,
      render: (_, record) => record?.concepto_de_evaluacion?.nombre || 'n/a'
      ,
    },
    {
      titleText: 'Unidad de Incidencia',
      dataIndex: 'tipo_de_unidad_de_incidencia',
      key: 'tipo_de_unidad_de_incidencia',
      width: 200,
      render: (_, record) => record?.tipo_de_unidad_de_incidencia?.descripcion || 'n/a',
    },
    {
      titleText: 'Cantidad de Incidencias',
      dataIndex: 'cantidad_de_incidencia',
      key: 'cantidad_de_incidencia',
      width: 300,
    },
    {
      titleText: 'Cantidad de Descuento',
      dataIndex: 'cantidad_de_descuento',
      key: 'cantidad_de_descuento',
      width: 300,
    },
    {
      titleText: 'Unidad de Descuento',
      dataIndex: 'tipo_de_incidencia_unidad_de_descuento',
      key: 'tipo_de_incidencia_unidad_de_descuento',
      width: 120,
      render: (_, record) => record?.tipo_de_incidencia_unidad_de_descuento?.descripcion || 'n/a',
    },
    {
      titleText: 'Acepta Justificación',
      dataIndex: 'acepta_justificacion',
      key: 'acepta_justificacion',
      width: 120,
      render: (val) => (val ? 'Si' : 'No'),
    },
    {
      titleText: 'Orden de Descuento',
      dataIndex: 'orden_de_descuento',
      key: 'orden_de_descuento',
      width: 120,
    },
    {
      titleText: 'Columna de Evaluación',
      dataIndex: 'evaluacion_interno',
      key: 'evaluacion_interno',
      width: 150,
      render: (_, record) => record?.evaluacion_interno?.nombre || 'n/a',
    },
    {
      titleText: 'Minutos de Incidencia',
      dataIndex: 'minutos_de_incidencia',
      key: 'minutos_de_incidencia',
      width: 120,
      render: (val) => (val ? 'Si' : 'No'),
    },
    {
      titleText: 'Vigencia Final',
      dataIndex: 'vigencia_final',
      key: 'vigencia_final',
      width: 150,
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 180,
      render: (_, record) => record?.estados_globales?.descripcion || 'n/a',
    },
  ];

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
  };

  const handleNumbers = (fieldName) => (e) => {
    const rawValue = e.target.value;

    // Remove all non-digit characters
    const filtered = rawValue.replace(/\D/g, '');

    // Update the specified form field
    form.setFieldsValue({ [fieldName]: filtered });
  };
  return (
    <Row align="center" justify="center" className="container">
      <Col span={24}>
        <Spin tip="Cargando..." spinning={loading}>
          <Table
            cols={columns}
            data={data?.results || []}
            pagination={false}
            paginationCallback={fetchPaginated}
            count={data?.count || 0}
            rowSelection={rowSelection}
            handleOnRowClick={handleOnRowClick}
            controls={{
              onClickAdd,
              onClickEdit: () => onClickEdit(),
              onClickDelete,
            }}
            customActions={[
              {
                onClick: () => setVisibleAutorizar(true),
                permission: { model: 'incidenciaparametros', action: 'autorizar' },
                text: 'Autorizar',
                icon: <CheckCircleOutlined />,
                disabledBySelection: false,
                disabled: selectedData?.estados_globales?.id !== ESTATUS_ACTIVO,
                className: 'success',
              },
            ]}
            disableDelete={selectedData?.estados_globales?.id !== ESTATUS_ACTIVO}
            permission={permission}
            allowExportParam={false}
            allowSearch={false}
          />
          <Modal
            open={open}
            closable={false}
            maskClosable={!loading}
            keyboard={!loading}
            footer={null}
            title={(
              <FormSubmitControls
                label={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Parámetros`}
                onFinish={onFinish}
                onCancel={onCancel}
                loading={loading}
              />
            )}
            onCancel={onCancel}
            forceRender
          >
            <Form
              layout="vertical"
              form={form}
              onFinish={onFinish}
              scrollToFirstErrorDatePicker
              name="general"
              initialValues={{
                estados_globales: ESTATUS_ACTIVO,
                aplica_acumulado: false,
                acepta_justificacion: false,
              }}
            >
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="concepto_de_evaluacion"
                  label="Concepto de Evaluación"
                  rules={rules.required}
                  hasFeedback
                >
                  <Select
                    labelProp="nombre"
                    keyProp="id"
                    dataSource={evaluacionesAsistencia}
                    disabled={
                      disableFields
                    }
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="tipo_de_unidad_de_incidencia"
                  label="Unidad de Incidencia"
                  rules={rules.required}
                  hasFeedback
                >
                  <Select
                    labelProp="descripcion"
                    keyProp="id"
                    dataSource={unidadIncidencia}
                    disabled={
                      disableFields
                    }
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="cantidad_de_incidencia"
                  rules={rules.required}
                  label="Cantidad de Incidencias"
                  hasFeedback
                >
                  <Input
                    allowClear
                    onChange={handleNumbers('cantidad_de_incidencia')}
                    disabled={disableFields}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="cantidad_de_descuento"
                  rules={rules.required}
                  label="Cantidad de Descuento"
                  hasFeedback
                >
                  <Input
                    allowClear
                    onChange={handleNumbers('cantidad_de_descuento')}
                    disabled={disableFields}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="tipo_de_incidencia_unidad_de_descuento"
                  label="Unidad de Descuento"
                  rules={rules.required}
                  hasFeedback
                >
                  <Select
                    labelProp="descripcion"
                    keyProp="id"
                    dataSource={unidadIncidencia}
                    disabled={
                      disableFields
                    }
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="acepta_justificacion"
                  label="Acepta Justificación"
                  rules={rules.required}
                >
                  <Select
                    trueFalse
                    disabled={
                      disableFields
                    }
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="orden_de_descuento"
                  label="Orden de Descuento"
                  rules={rules.required}
                >
                  <Input
                    allowClear
                    onChange={handleNumber('orden_de_descuento')}
                    disabled={disableFields}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="evaluacion_interno"
                  label="Columna de Evaluación"
                  rules={rules.required}
                  hasFeedback
                >
                  <Select
                    labelProp="nombre"
                    keyProp="id"
                    dataSource={evaluacionInterna}
                    disabled={
                      disableFields
                    }
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="minutos_de_incidencia"
                  label="Minutos de Incidencia"
                  rules={rules.required}
                >
                  <Select
                    trueFalse
                    disabled={
                      disableFields
                    }
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="vigencia_final"
                  label="Vigencia Final"
                  hasFeedback
                >
                  <DatePicker
                    allowClear
                    format="YYYY-MM-DD"
                    disabled={isAdding || selectedData?.estados_globales?.id === ESTATUS_INACTIVO}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="estados_globales"
                  label="Estatus"
                  hasFeedback
                >
                  <Select
                    labelProp="descripcion"
                    keyProp="id"
                    dataSource={estados}
                    activeInactive={selectedData?.estados_globales?.id === ESTATUS_ACTIVO}
                    disabled={selectedRowKeys.length <= 0 || disableFields}
                    onChange={(val) => setVisibleConfirmInactivo(val === ESTATUS_INACTIVO)}
                  />
                </Form.Item>
              </Col>
              <Form.Item hidden>
                <Button htmlType="submit" />
              </Form.Item>
            </Form>
          </Modal>
          <ModalDelete
            onDelete={deleteItem}
            onCancel={() => setVisibleAlert(false)}
            open={visibleAlert}
            content={`Parámetro ${form.getFieldValue('concepto_de_evaluacion')?.nombre || ''}`}
            loading={loading}
          />
          <ModalConfirmation
            onFinish={onConfirmAutorizar}
            ConfirmAutorize
            onCancel={() => setVisibleAutorizar(false)}
            contentTitle={`Autorizar Parámetro ${form.getFieldValue('concepto_de_evaluacion')?.nombre || ''}`}
            open={visibleAutorizar}
            loading={loading}
          />
          <ModalConfirmation
            onFinish={() => setVisibleConfirmInactivo(false)}
            ConfirmInactive
            onCancel={() => {
              form.setFieldValue('estados_globales', ESTATUS_ACTIVO);
              setVisibleConfirmInactivo(false);
            }}
            open={visibleConfirmInactivo}
            contentTitle={`Inactivar Parámetro ${form.getFieldValue('concepto_de_evaluacion')?.nombre || ''}`}
            loading={loading}
          />
        </Spin>
      </Col>
    </Row>
  );
};

export default ParamaetrosConfigReloj;
